import { render, staticRenderFns } from "./table4.vue?vue&type=template&id=74a72e75&scoped=true"
import script from "./table4.vue?vue&type=script&lang=js"
export * from "./table4.vue?vue&type=script&lang=js"
import style0 from "./table4.vue?vue&type=style&index=0&id=74a72e75&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a72e75",
  null
  
)

export default component.exports